import { render, staticRenderFns } from "./EdocNew.vue?vue&type=template&id=fbd2af02"
import script from "./EdocNew.vue?vue&type=script&lang=js"
export * from "./EdocNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports